<script>

// import Header from "../lib/header.svelte";
//   import Menu from "../lib/menu.svelte";
//   import Footer from "../lib/footer.svelte";
//   import barmouthimage from "../lib/images/barmouth.jpg";
//   import restint from "../lib/images/restint.jpg";
//   import restext from "../lib/images/restext1.jpg";
//   import gmap from "../lib/images/gmap.jpg";
//   import ywarwslivingroom from "../lib/images/YWarws/ywarws-living-room.jpg";
//   import ywarwsbedroom from "../lib/images/YWarws/ywarws-bedroom.jpg";
//   import ywarwswindow from "../lib/images/YWarws/ywarws-window.jpg";
</script>


<main>
    <p>
      Self Catering Holiday Cottages near Dolgellau at the head of the Mawddach
      valley within the Snowdonia National Park. Mawddach Cottages are former farm
      outhouses tastefully converted into 2 semi-detached cottages. These are
      contained within Maesygarnedd Farm in the small village of Llanelltyd (2.5
      miles from Dolgellau and 7 miles from Barmouth). Free Wi Fi is available in
      all the properties.
    </p>
    <img src='/images/barmouth.jpg' alt="barmouth" />
    <p>
      This is an ideal location for touring North and Mid Wales, for those wishing
      to relax in the peace and quiet of the countryside whilst a lively seaside
      atmosphere and sandy beaches can be found only 7 miles away at Barmouth.
    </p>
    <div class="pizzeria">
      <div class="p1">
        <img class='flexibleimage' src='/images/restint.jpg' alt="pizzeria & bar barmouth" />
        <p>
          There is an excellent pizzeria & bar on site with indoor and outdoor
          seating within walking distance of all the self catering accommodation.
        </p>
        <a href="https://www.mawddach.com/"><button>Link to pizzeria</button></a>
      </div>
      <div class="p2"><img class='flexibleimage' src='/images/restext.jpg' alt="pizzeria & bar barmouth" /></div>
    </div>
    <p>
      The river Mawddach flows through the farmland and the position of each
      accommodation affords beautiful views of Cader Idris mountain range and the
      Mawddach Estuary. Each accommodation has it's own private enclosed patio
      area and private parking. Garden furniture and barbecue provided.
    </p>
    <div class="acc">
      <img class='flexibleimage' src='/images/YWarws/ywarws-bedroom.jpg' alt="" />
      <img class='flexibleimage' src='/images/ywarws/ywarws-window.jpg' alt="" />
      <img class='flexibleimage' src='/images/ywarws/ywarws-living-room.jpg' alt="" />
    </div>
    <p>
      There are several excellent walks close by (including Cader Idris, the
      Precipice Walks and Mawddach trail). The Coed y Brenin Cycle Centre is 5
      miles from the accommodation and is renowned for it's cycling routes. River
      and lake fishing, pony trekking, golf, bird watching, miniature railways and
      historic castles are all activities within easy reach of the accommodation.
    </p>
    <p>Lockable storage and cleaning facilities for bicycles</p>
    <div class='directions'>
    <a href="https://www.google.com/maps/place/Mawddach+Cottages/@52.756697,-3.9159499,17z/data=!3m1!4b1!4m6!3m5!1s0x48657b058290c92d:0x98ee03a2758f173e!8m2!3d52.756697!4d-3.913375!16s%2Fg%2F1tdb87tx?entry=ttu" target="_blank"><img src='/images/gmap.jpg' alt="map" /></a>
  </div>
  
    
  </main>

  
  <style>
      .directions img{
          max-width: 100%;
      }
    button {
      background-color: #cbad81;
      margin: 12px;
      border-radius: 5px 25px 0 30px;
      border-color: #cbad81;
      padding: 5px 15px 5px 15px;
      color: rgb(255, 255, 255);
      font-size: x-large;
    }
    button:hover {
      background-color: #e8d1af;
      cursor: pointer;
    }
    main {
      background-color: #67aac9;
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 60vw;
      margin: auto;
    }
    .pizzeria {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-top: 50px;
    }
    .p1 {
      padding-right: 80px;
    }
    .p2 img {
      width: 100%;
    }
    .p1 img {
      width: 100%;
    }
    .acc {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .acc img {
      width: 30%;
    }
    @media screen and (max-width: 800px) {
      main {
        width: 100%;
        padding: 10px;
      }
      .flexibleimage{
          width:100%;
          margin: auto;
      }
      .pizzeria {
          flex-direction: column;
      }
      .pizzeria img{
          width:100%;
      }
      .acc {
      flex-direction: column;
      margin: auto;
      }
      .acc img{
          width: 100%;
      }
      .p1 {
      padding-right: 0px;
    }
  
    }
  </style>
  